<form [formGroup]="form" *ngIf="form">
  <div [dir]="data.dir" class="row">
    <div class="col-sm-6">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.mistakeLevel" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="mistakeLevel" (selectionChange)="changeMistakeLevel()">
          <mat-option *ngFor="let option of mistakeLevels" [value]="option.key">
            {{ option.label | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    
    <div class="col-sm-6" *ngIf="form?.controls?.mistakeLevel?.value == criterionKey">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.Criterion" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="criterionKey">
          <mat-option *ngFor="let option of criterions$ | async" [value]="option.criterionKey">
            {{option.criterionKey}} - 
            {{
              option
              | propertyLocalized : ["criterionArabicName", "criterionEnglishName"]
              | async
              }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    
    <div class="col-sm-12 mb-2">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.mistake" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="mistake"></textarea>
      </mat-form-field>
    </div>

    <div class="col-sm-12 mb-2">
      <mat-label class="font-weight-bold field-required">
        {{ "forms.common.Criteria.suggestedSolution" | translate }}
      </mat-label>
      <mat-form-field appearance="outline">
        <textarea matInput cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3" formControlName="suggestedSolution"></textarea>
      </mat-form-field>
    </div>

    <div class="col-sm-12 mt-2 d-flex justify-content-end">
      <button mat-flat-button (click)="cancel()" [ngClass]="{'mx-2': !data.viewOnly}">
        {{ "forms.common.cancel" | translate }}
      </button>
      <button *ngIf="!data.viewOnly" mat-flat-button (click)="save()" color="primary" [disabled]="form.invalid">
        {{ "forms.common.Criteria.save" | translate }}
      </button>
    </div>
  </div>
</form>